import React, { useState } from "react";

export default function AllowedCurrencies() {
  const [selectedCurrencies, setSelectedCurrencies] = useState([]);
  const [updated, setUpdated] = useState(false);

  const currencyOptions = [
    { id: "usd", name: "USD" },
    { id: "eur", name: "EUR" },
    { id: "ngn", name: "NGN" },
    { id: "gbp", name: "GBP" },
    { id: "jpy", name: "JPY" },
    { id: "cad", name: "CAD" },
    { id: "aud", name: "AUD" },
    { id: "cny", name: "CNY" },
    { id: "inr", name: "INR" },
    { id: "zar", name: "ZAR" },
    { id: "brl", name: "BRL" },
    { id: "mxn", name: "MXN" },
  ];

  const handleCheckboxChange = (currency) => {
    setSelectedCurrencies((prevSelected) =>
      prevSelected.includes(currency)
        ? prevSelected.filter((item) => item !== currency)
        : [...prevSelected, currency]
    );
  };

  const isChecked = (currency) => selectedCurrencies.includes(currency);

  const handleUpdateClick = () => {
    setUpdated(true);
    console.log("Selected Currencies:", selectedCurrencies);
    setTimeout(() => setUpdated(false), 3000); // Reset the update message after 3 seconds
  };

  return (
    <div className="gateway-settings-tab">
      <div className="currencies-container">
        <h5>Select Allowed Currencies</h5>
        <div className="currencies-list">
          {currencyOptions.map((currency) => (
            <div key={currency.id} className="currency-option">
              <input
                type="checkbox"
                id={currency.id}
                value={currency.name}
                checked={isChecked(currency.name)}
                onChange={() => handleCheckboxChange(currency.name)}
              />
              <label htmlFor={currency.id}>{currency.name}</label>
            </div>
          ))}
        </div>

        {/* Output Selected Currencies */}
        <div className="selected-currencies">
          <h6>Selected Currencies:</h6>
          {selectedCurrencies.length > 0 ? (
            <ul>
              {selectedCurrencies.map((currency) => (
                <li key={currency}>{currency}</li>
              ))}
            </ul>
          ) : (
            <p>No currency selected</p>
          )}
        </div>

        {/* Update Button */}
        <button className="update-btn" onClick={handleUpdateClick}>
          Update Selected Currencies
        </button>

        {/* Show Success Message after Update */}
        {updated && (
          <p className="update-message">
            Selected currencies updated successfully!
          </p>
        )}
      </div>
    </div>
  );
}
